export type FeedItem = {
  id: number;
  time: string;
  cat: string;
  title: string;
  summary: string;
  heat: number;
  tag: string;
};

export type RankItem = {
  rank: number;
  title: string;
  cat: string;
  heat: number;
  delta: string;
  trend: "up" | "down" | "flat";
  time: string;
};

export type TimelineStep = {
  time: string;
  title: string;
  desc: string;
};

export type TopicItem = {
  name: string;
  count: number;
  cat: string;
  size: "lg" | "md" | "sm";
};

export type AnalysisItem = {
  id: number;
  cat: string;
  title: string;
  summary: string;
  read: string;
  image: string;
};

export type ReplayItem = {
  no: string;
  title: string;
  summary: string;
  steps: number;
  cat: string;
  image: string;
};

export const tickerItems: string[] = [
  "更新 · 年度都市剧口碑两极，是剧本平庸还是观众变了？",
  "更新 · 顶流演唱会「假唱」疑云，声学报告成关键证据",
  "更新 · 跨界直播带货翻车，谁来为选品失误负责？",
  "更新 · 游戏主播转会风云，合同细节逐字拆解",
  "更新 · 综艺剪辑之争再起，真相还原到哪一环？",
  "更新 · 品牌联名翻车全记录，粉丝为何集体倒戈？",
  "更新 · 选秀节目排名风波，前因后果一次讲透",
];

export const hotChips: string[] = [
  "演唱会假唱疑云",
  "直播带货翻车",
  "综艺剪辑之争",
  "主播转会风云",
  "联名风波",
  "盛典名场面",
];

export const quickFeed: FeedItem[] = [
  {
    id: 1,
    time: "09-05 09:40",
    cat: "直播",
    title: "头部主播选品失误被质疑：供应链环节失守在哪一步？",
    summary: "从选品清单到上播质检，复盘整条链路，看口碑崩塌究竟从哪一环开始。",
    heat: 92,
    tag: "进行中",
  },
  {
    id: 2,
    time: "09-05 08:12",
    cat: "综艺",
    title: "年度盛典名场面盘点：热度峰值前后的三段关键转折",
    summary: "颁奖、发言、离场三个节点被反复解读，我们把原始时间线对齐重看一遍。",
    heat: 88,
    tag: "爆",
  },
  {
    id: 3,
    time: "09-04 22:30",
    cat: "音乐",
    title: "「假唱」声学报告公开，鉴定的边界到底在哪？",
    summary: "波形比对能否定论？技术派与直觉派各执一词，前因后果需要冷静拆解。",
    heat: 96,
    tag: "热议",
  },
  {
    id: 4,
    time: "09-04 20:05",
    cat: "电竞",
    title: "头部主播转会谈判细节流出，违约金数字背后是谁的筹码？",
    summary: "一份合同草案引发的连锁反应，俱乐部、平台与主播三方诉求逐条对照。",
    heat: 74,
    tag: "新瓜",
  },
];

export const trendBoard: RankItem[] = [
  { rank: 1, title: "演唱会「假唱」疑云持续发酵，声学报告引热议", cat: "音乐", heat: 98, delta: "+1.2万", trend: "up", time: "热度·今日峰值" },
  { rank: 2, title: "头部主播选品翻车，消费者维权群人数破三万", cat: "直播", heat: 95, delta: "+8600", trend: "up", time: "上升最快" },
  { rank: 3, title: "年度都市剧大结局口碑两极，编剧回应引二轮讨论", cat: "影视", heat: 90, delta: "-1200", trend: "down", time: "热度·回落" },
  { rank: 4, title: "平台下架争议切片，综艺剪辑之争再掀波澜", cat: "综艺", heat: 86, delta: "+5300", trend: "up", time: "上升最快" },
  { rank: 5, title: "品牌联名海报被扒旧图，粉丝立场两极分化", cat: "品牌", heat: 79, delta: "+3400", trend: "flat", time: "热度·稳定" },
  { rank: 6, title: "游戏主播转会落定，背后三方合同细节拆解", cat: "电竞", heat: 72, delta: "-700", trend: "down", time: "热度·回落" },
];

export const timelineSteps: TimelineStep[] = [
  { time: "08-30 20:10", title: "现场直播开唱", desc: "演出进行到第 18 首歌时，直播间弹幕开始出现「口型对不上」的质疑。" },
  { time: "08-30 23:40", title: "切片开始疯传", desc: "粉丝与路人录制的三段片段在社交平台累计播放破千万，话题词登上热搜前五。" },
  { time: "08-31 09:00", title: "工作室首度回应", desc: "凌晨声明称「纯属技术误判」，并放出一段彩排花絮作为佐证，舆论分化加剧。" },
  { time: "09-01 15:20", title: "声学报告流出", desc: "一份标注「非官方」的分析报告对比了现场与录音频谱，将讨论推向技术层面。" },
  { time: "09-02 11:00", title: "主办方补发完整版", desc: "主办方放出无剪辑全场录像，逐帧对照成为新焦点，事件进入关键复盘阶段。" },
  { time: "09-03 18:00", title: "多方声明齐发", desc: "歌手本人、演出团队与音控方先后发声，各方时间线需要逐条对齐还原。" },
];

export const topicItems: TopicItem[] = [
  { name: "#演唱会假唱争议", count: 6.8, cat: "音乐", size: "lg" },
  { name: "#直播翻车复盘", count: 4.2, cat: "直播", size: "lg" },
  { name: "#综艺剪辑之争", count: 3.1, cat: "综艺", size: "md" },
  { name: "#年度剧口碑两极", count: 2.7, cat: "影视", size: "md" },
  { name: "#主播转会风云", count: 2.2, cat: "电竞", size: "sm" },
  { name: "#联名海报被扒", count: 1.9, cat: "品牌", size: "md" },
  { name: "#盛典名场面", count: 1.6, cat: "综艺", size: "sm" },
  { name: "#选秀排名风波", count: 1.4, cat: "综艺", size: "sm" },
  { name: "#品牌危机公关", count: 1.1, cat: "品牌", size: "lg" },
  { name: "#配音替身争议", count: 0.9, cat: "影视", size: "sm" },
  { name: "#电竞合同细节", count: 0.8, cat: "电竞", size: "md" },
  { name: "#跨年舞台灯光", count: 0.6, cat: "音乐", size: "sm" },
];

export const analysisList: AnalysisItem[] = [
  {
    id: 1,
    cat: "音乐",
    title: "「假唱」疑云前因后果背景解析：技术鉴定能一锤定音吗？",
    summary: "波形、频谱、干声比对——把声学鉴定的边界讲透，也把「口型对不上」这类民间判断到底靠不靠谱讲明白。",
    read: "9分钟读完",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20magazine%20illustration%20of%20a%20microphone%20with%20soundwave%20and%20audio%20waveform%20bars%20in%20soft%20watermelon%20red%20and%20cream%20tone%2C%20flat%20minimal%20design%2C%20soft%20rounded%20shapes%2C%20studio%20warm%20lighting%2C%20clean%20composition%20with%20gentle%20shadows&width=800&height=800&seq=gua-ana-01&orientation=squarish",
  },
  {
    id: 2,
    cat: "综艺",
    title: "综艺剪辑之争背后：节目组、嘉宾与平台的「三方时间线」",
    summary: "一次剪辑为什么能吵上热搜？我们比对了发布版与未播片段，把争议发生的前因后果还原成一张可对照的时间线。",
    read: "12分钟读完",
    image: "https://readdy.ai/api/search-image?query=editorial%20magazine%20illustration%20of%20film%20editing%20timeline%20clips%20and%20play%20button%20icons%20arranged%20like%20a%20storyboard%20in%20warm%20amber%20orange%20and%20cream%20tones%2C%20flat%20minimal%2C%20soft%20rounded%20shapes%2C%20warm%20studio%20light%2C%20clean%20harmonious%20layout&width=800&height=800&seq=gua-ana-02&orientation=squarish",
  },
  {
    id: 3,
    cat: "直播",
    title: "直播带货翻车完整复盘：从选品到售后的每个失守环节",
    summary: "口碑崩塌从来不是一夜之间。我们把选品、质检、上播、售后四条链路摊开，逐环节标注风险点与应对窗口。",
    read: "8分钟读完",
    image: "https://readdy.ai/api/search-image?query=editorial%20magazine%20illustration%20of%20a%20shopping%20cart%20with%20package%20boxes%20and%20route%20flow%20arrows%20in%20watermelon%20green%20and%20cream%20tone%2C%20flat%20minimal%20design%2C%20soft%20rounded%20shapes%2C%20warm%20lighting%2C%20clean%20and%20balanced%20composition&width=800&height=800&seq=gua-ana-03&orientation=squarish",
  },
];

export const replayList: ReplayItem[] = [
  {
    no: "01",
    title: "跨年直播「假唱」事件全档案",
    summary: "从现场片段到多方回应，用可核验的时间线把整件事一次讲透，理清「技术误判」到底有没有说服力。",
    steps: 6,
    cat: "音乐",
    image: "https://readdy.ai/api/search-image?query=wide%20editorial%20illustration%20of%20a%20stage%20spotlight%20and%20a%20long%20horizontal%20timeline%20road%20with%20milestone%20pins%20in%20watermelon%20red%20cream%20and%20amber%2C%20flat%20minimal%20magazine%20art%2C%20warm%20soft%20light%2C%20clean%20balanced%20composition&width=900&height=680&seq=gua-rp-01&orientation=landscape",
  },
  {
    no: "02",
    title: "综艺剪辑争议：谁动了那「一刀」？",
    summary: "节目组立场、嘉宾回应与网友切片三线并进，逐条对表还原争议发生的时间节点与背后动机。",
    steps: 5,
    cat: "综艺",
    image: "https://readdy.ai/api/search-image?query=wide%20editorial%20illustration%20of%20scissors%20cutting%20a%20film%20strip%20with%20frames%20scattered%20as%20an%20open%20book%20in%20amber%20orange%20and%20cream%20tones%2C%20flat%20minimal%20magazine%20art%2C%20warm%20soft%20light%2C%20clean%20harmonious%20layout&width=900&height=680&seq=gua-rp-02&orientation=landscape",
  },
  {
    no: "03",
    title: "主播转会落槌：合同里的那些数字",
    summary: "违约金、年限与分成被反复比较，我们用公开信息拼出三方谈判的完整背景，讲清「天价」从何而来。",
    steps: 7,
    cat: "电竞",
    image: "https://readdy.ai/api/search-image?query=wide%20editorial%20illustration%20of%20a%20handshake%20over%20a%20contract%20document%20with%20coins%20and%20arrow%20chart%20in%20watermelon%20green%20cream%20and%20amber%2C%20flat%20minimal%20magazine%20art%2C%20warm%20soft%20light%2C%20clean%20layout&width=900&height=680&seq=gua-rp-03&orientation=landscape",
  },
];

export const entryTiles = [
  { icon: "ri-fire-line", title: "热度榜", desc: "今日最热 6 条瓜点实时排序", href: "#board" },
  { icon: "ri-time-line", title: "时间线", desc: "重点事件按节点逐帧还原", href: "#timeline" },
  { icon: "ri-price-tag-3-line", title: "话题墙", desc: "12 个正在发酵的吃瓜话题", href: "#topics" },
  { icon: "ri-file-list-3-line", title: "背景解析", desc: "前因后果一次讲透的深读", href: "#analysis" },
  { icon: "ri-clipboard-line", title: "完整复盘", desc: "系列专题档案一键直达", href: "#replay" },
];